module.exports = __webpack_public_path__ + "img/1-min.4c4bcc96.jpg";